module.exports = __webpack_public_path__ + "static/media/bled_slovinia.41942696.jpg";